import { Navigate } from 'react-router-dom';
import { useTenant } from '../../../providers/TenantProvider';
import { LoadingSpinner } from './LoadingSpinner';

interface ModuleGuardProps {
  modulo: string;
  children: React.ReactNode;
}

export function ModuleGuard({ modulo, children }: ModuleGuardProps) {
  const { tieneModulo, loading } = useTenant();

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
        }}
      >
        <LoadingSpinner size="md" muted />
      </div>
    );
  }

  if (!tieneModulo(modulo)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
